import { useStoreActions } from "../../../contexts";
import { useMutationState } from "../useMutationState";
export const useUndoServiceDescription = () => {
  const {
    api
  } = useStoreActions();
  const {
    mutateAsync,
    isPending
  } = useMutationState({
    mutationFn: async conversationId => {
      return api.service.undoDescription(conversationId);
    },
    withPageLoader: false
  });
  return {
    undoDescription: mutateAsync,
    isLoading: isPending
  };
};